import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";
import { fetchContent } from "../commerce";

const LANG_KEY = "cafexir-lang";
const LanguageContext = createContext(null);

const get = (obj, path) =>
  path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), obj);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem(LANG_KEY) === "ar" ? "ar" : "en";
    } catch {
      return "en";
    }
  });
  // Admin-editable copy overrides (CMS). Keyed by translation path.
  const [overrides, setOverrides] = useState({});

  useEffect(() => {
    fetchContent().then(setOverrides);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.lang = lang;
    root.dir = lang === "ar" ? "rtl" : "ltr";
    try {
      localStorage.setItem(LANG_KEY, lang);
    } catch {}
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      isRtl: lang === "ar",
      setLang,
      toggleLang: () => setLang((l) => (l === "ar" ? "en" : "ar")),
      t: (path) => {
        const ov = overrides[path];
        if (ov && ov[lang]) return ov[lang];
        return get(translations[lang], path) ?? get(translations.en, path) ?? path;
      },
    }),
    [lang, overrides]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
